import { env } from 'src/config/env';
import { useEffect } from 'react';

type TtqInstance = unknown[] & { _u?: string };

type Ttq = unknown[] & {
  methods?: string[];
  setAndDefer?: (target: unknown[], method: string) => void;
  instance?: (id: string) => unknown[];
  load?: (id: string, options?: Record<string, unknown>) => void;
  _i?: Record<string, TtqInstance>;
  _t?: Record<string, number>;
  _o?: Record<string, Record<string, unknown>>;
};

declare global {
  interface Window {
    TiktokAnalyticsObject?: string;
    ttq?: Ttq;
  }
}

const setAndDefer = (target: unknown[], method: string) => {
  Reflect.set(target, method, (...args: unknown[]) => {
    target.push([method, ...args]);
  });
};

const TikTokPixel = () => {
  useEffect(() => {
    if (env.mode !== 'production') {
      return;
    }

    (function (w: Window, d: Document, t: string) {
      w.TiktokAnalyticsObject = t;
      const ttq: Ttq = (w.ttq = w.ttq || []);
      const methods = [
        'page',
        'track',
        'identify',
        'instances',
        'debug',
        'on',
        'off',
        'once',
        'ready',
        'alias',
        'group',
        'enableCookie',
        'disableCookie',
        'holdConsent',
        'revokeConsent',
        'grantConsent',
      ];
      ttq.methods = methods;
      ttq.setAndDefer = setAndDefer;
      for (let i = 0; i < methods.length; i++) {
        setAndDefer(ttq, methods[i]);
      }
      ttq.instance = function (id) {
        const e = ttq._i?.[id] || [];
        for (let n = 0; n < methods.length; n++) setAndDefer(e, methods[n]);
        return e;
      };
      ttq.load = function (id, options) {
        const r = 'https://analytics.tiktok.com/i18n/pixel/events.js';
        ttq._i = ttq._i || {};
        ttq._i[id] = Object.assign([], { _u: r });
        ttq._t = ttq._t || {};
        ttq._t[id] = +new Date();
        ttq._o = ttq._o || {};
        ttq._o[id] = options || {};
        const script = d.createElement('script');
        script.type = 'text/javascript';
        script.async = !0;
        script.src = r + '?sdkid=' + id + '&lib=' + t;
        const first = d.getElementsByTagName('script')[0];
        first.parentNode?.insertBefore(script, first);
      };

      ttq.load('CSB6M3RC77U8VDFFIQJ0');
      const page = Reflect.get(ttq, 'page');
      if (typeof page === 'function') page.call(ttq);
    })(window, document, 'ttq');
  }, []);

  return null;
};

export default TikTokPixel;
